import { Map, Set } from 'immutable';

const applicationMappings = (featureFlags) => {
  if (featureFlags.enableJsdToJsm) {
    return Set([
      Map({
        addonDiscoveryKey: 'jsd',
        pathParamKey: 'jsm',
      }),
      Map({
        addonDiscoveryKey: 'jsd',
        pathParamKey: 'jira-service-management',
      }),
      Map({ addonDiscoveryKey: 'fecru', pathParamKey: 'fisheye-crucible' }),
    ]);
  }
  return Set([
    Map({
      addonDiscoveryKey: 'jsd',
      pathParamKey: 'jira-service-desk',
    }),
    Map({ addonDiscoveryKey: 'fecru', pathParamKey: 'fisheye-crucible' }),
  ]);
};

export const fromAddonDiscoveryAppMappings = (featureFlags = {}) => {
  return applicationMappings(featureFlags).reduce(
    (acc, am) => acc.set(am.get('addonDiscoveryKey'), am.get('pathParamKey')),
    Map()
  );
};

export const toAddonDiscoveryAppMappings = (featureFlags = {}) => {
  return applicationMappings(featureFlags).reduce(
    (acc, am) => acc.set(am.get('pathParamKey'), am.get('addonDiscoveryKey')),
    Map()
  );
};

const sortMappings = Set([
  Map({ addonDiscoveryKey: 'topRated', pathParamKey: 'top-rated' }),
  Map({ addonDiscoveryKey: 'topSelling', pathParamKey: 'top-selling' }),
]);
export const fromAddonDiscoverySortMappings = sortMappings.reduce(
  (acc, am) => acc.set(am.get('addonDiscoveryKey'), am.get('pathParamKey')),
  Map()
);
export const toAddonDiscoverySortMappings = sortMappings.reduce(
  (acc, am) => acc.set(am.get('pathParamKey'), am.get('addonDiscoveryKey')),
  Map()
);
